<template>
    <div ref="popupContainer" >
		<vs-popup
    :title="'Supprimer: ' + thisThema.name"
    :active.sync="isValidationPopupActive">
	<div style="display:flex; justify-content: space-around;">
		<vs-button @click="isPopupActive=false"> Non</vs-button>
		<vs-button @click="deleteThema()" color="danger"> Oui</vs-button>
	</div>
    </vs-popup>

          <vs-table
            max-items="20"
            stripe
            :data="netlinkThemaList"
          >
            <template slot="thead">
              <vs-th class="th-sticky">Pays</vs-th>
              <vs-th class="th-sticky">Niveau</vs-th>
              <!-- <vs-th>Type de prestation</vs-th> -->
              <vs-th class="th-sticky" v-if="$acl.check('admin')"></vs-th>
              <vs-th class="th-sticky" v-if="$acl.check('sadmin')"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(tr, index) in data">
                <!-- <div v-show="false">
                    {{setRowNum(data.length)}}
                </div> -->

                <vs-td >{{ tr.country }}</vs-td>
                <vs-td>{{ tr.level }}</vs-td>
                <!-- <vs-td>{{ getNetlinkName(tr.is_netlink) }}</vs-td> -->
                <vs-td v-if="$acl.check('admin')" style="text-align: center;">
                  <vx-tooltip text="Modifier" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
                    <vs-button
                        size="large"
                        color="primary"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-edit-2"
                        @click="displayEditPopup(tr)"
                    ></vs-button>
                  </vx-tooltip>
                </vs-td>
                <vs-td v-if="$acl.check('sadmin')" style="text-align: center;">
                    <vx-tooltip text="Effacer" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
                        <vs-button
                            size="large"
                            color="danger"
                            type="flat"
                            icon-pack="feather"
                            icon="icon-trash-2"
                            @click="displayValidationPopup(tr)"
                        ></vs-button>
                    </vx-tooltip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
    </div>
    </template>
<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import NetlinkThemaIntlPopup from "@/components/popups/NetlinkIntlPopup";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/plugins/monthSelect/style.css";

export default {
	name: "NetlinkInternationalTable",
	components: {
		NetlinkThemaIntlPopup
		/*
		 * PurchaseForm,
		 * NetlinkTable,
		 * PurchasesTable,
		 * flatPickr
		 */
	},
	props: {

	},
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			idEdit: true,
			isPopupActive: false,
			isValidationPopupActive: false,
			apiUrl: this.$store.state.backendApiUrl,
			thisThema: {}
		};
	},
	created() {
		store.dispatch("getAllNetlinkIntl");
	},
	mounted() {



	},
	watch: {

	},
	computed: {
		netlinkThemaList: () => {
			return store.state.netlinkIntl;
		}
	},
	methods: {
		displayEditPopup(tr){
			this.$emit("edit-popup", tr);
		},
		closethemaPopup(){
			this.isPopupActive = false;
		},
		addnewThema(){
			this.idEdit = false;
			this.isPopupActive = true;
			const obj = {
				idEdit: false, isPopupActive: true
			};
			//console.log("bedore popup");
			this.$emit("inter-popup", obj);
			//console.log("after popup");
		},
		displayValidationPopup(tr){
			this.isValidationPopupActive = true;
			this.thisThema = tr;
		},
		async deleteThema(){
			try{
				await this.$http.delete(this.apiUrl + "netlink/netlinkIntl/del/"+ this.thisThema.id);
				this.$vs.notify({
					title: "Succès",
					text: "Thématique supprimé avec succès."
				});
				this.isValidationPopupActive = false;
				store.dispatch("getAllNetlinkIntl");

			}
			catch(err){
				this.$vs.notify({
					title: "Echec",
					text: "Error " + err.toString()
				});
			}
		}
	}};
</script>